import { lazy } from 'react';
/** Открывает форму уровня кэшбэка */
export const CashbackLevelFormPageAsync = lazy(() => import('./CashbackLevelForm/CashbackLevelFormPage'));
